module.exports = __webpack_public_path__ + "static/media/champion03.17836c85.jpg";